import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { LenderPortalStore } from '../stores';

export const useLenderPortalStore = () =>
  useContext<LenderPortalStore>(StoreContext);
